// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"2e04253d608b939c346f","993":"0b5a4c29792a6c28c585"}[chunkId] + ".js");